// src/icons/svgs/underline.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgUnderline = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 28 28", ref, ...props, children: /* @__PURE__ */ jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M7.778 4.389a.778.778 0 0 0-1.556 0v8.167a7.778 7.778 0 1 0 15.556 0V4.389a.778.778 0 1 0-1.555 0v8.167a6.222 6.222 0 0 1-12.445 0zM4.667 23.833a.778.778 0 1 0 0 1.556h18.667a.778.778 0 0 0 0-1.556z", clipRule: "evenodd" }) });
var ForwardRef = forwardRef(SvgUnderline);
var underline_default = ForwardRef;
export {
  underline_default as TextUnderline
};
